/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { Fragment, useEffect, useRef, useState } from 'react';

import filterMenuStyle from '../FiltersMenu/styles';
import { ToolTipIcon } from '../Icons';
import TooltipInfo from '../TooltipInfo';
import useStyles from './styles';

const FilterByDisability = ({
  onSave,
  currentValue: value,
  onErrorChange,
  filterShowHide,
}) => {
  const styles = useStyles();

  const filterMenuStyles = filterMenuStyle();

  const [currentValue, setCurrentValue] = useState(value);

  const lastSavedValue = useRef(value || '');

  // Handle input change
  const handleDisabilityChange = e => {
    const val = Number(e.target.value);
    setCurrentValue(val);
  };

  // Call onSave only after currentValue updates
  useEffect(() => {
    if (currentValue !== lastSavedValue.current) {
      onSave({
        Disabilityoption: currentValue,
      });
      lastSavedValue.current = currentValue;
    }
  }, [currentValue, onSave]);

  // for clear filter Sync local state with prop changes
  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  return (
    <Fragment>
      <div css={filterMenuStyles.filterHead}>
        <h5 css={filterMenuStyles.filterTitle}>
          Disability Football
          <span>
            <TooltipInfo icon={<ToolTipIcon />} headTitle="Disability Football">
              <>
                <div>
                  <strong>Any</strong>
                  Shows all football opportunities including non-disability and
                  disability specific formats.
                </div>
                <div>
                  <strong>Non-disability</strong>
                  Shows all non-disability specific football opportunities.
                </div>
                <div>
                  <strong>Disability</strong>
                  Shows all disability specific opportunities. Select your
                  preferred format(s) from the list. For more information about
                  disability football formats, visit England Football:{' '}
                  <a
                    href="https://www.englandfootball.com/play/Disability-Football"
                    target="_blank"
                    rel="noreferrer"
                    ipInfo
                  >
                    https://www.englandfootball.com/play/Disability-Football
                  </a>
                </div>
              </>
            </TooltipInfo>
          </span>
        </h5>
      </div>
      <div css={filterMenuStyles.filterBody}>
        <div css={styles.radioButtons}>
          <input
            type="radio"
            id="not-sure"
            name="disabilityType"
            value={3}
            checked={currentValue === 3}
            onChange={handleDisabilityChange}
            css={styles.radioInput}
            tabIndex={filterShowHide ? 0 : -1}
          />
          <label
            htmlFor="not-sure"
            css={[
              styles.radioLabel,
              currentValue === 3 && styles.radioLabelChecked,
            ]}
          >
            <span css={styles.labelText}>Any</span>
          </label>

          <input
            type="radio"
            id="non-disability"
            name="disabilityType"
            value={2}
            checked={currentValue === 2}
            onChange={handleDisabilityChange}
            css={styles.radioInput}
            tabIndex={filterShowHide ? 0 : -1}
          />
          <label
            htmlFor="non-disability"
            css={[
              styles.radioLabel,
              currentValue === 2 && styles.radioLabelChecked,
            ]}
          >
            <span css={styles.labelText}>Non-disability</span>
          </label>

          <input
            type="radio"
            id="disability"
            name="disabilityType"
            value={1}
            checked={currentValue === 1}
            onChange={handleDisabilityChange}
            css={styles.radioInput}
            tabIndex={filterShowHide ? 0 : -1}
          />
          <label
            htmlFor="disability"
            css={[
              styles.radioLabel,
              currentValue === 1 && styles.radioLabelChecked,
            ]}
          >
            <span css={styles.labelText}>Disability</span>
          </label>
        </div>
      </div>
    </Fragment>
  );
};

FilterByDisability.propTypes = {
  currentValue: PropTypes.number,
  onSave: PropTypes.func,
};

export default FilterByDisability;
